import React from "react";
import PropTypes from "prop-types";

import { useBooleanState } from "hooks";

import {
  useClientResources,
  useContactSelector,
  useMergeContactAction,
} from "./hooks";
import {
  Button,
  MergeConfirmationModal,
  Popper,
  SimpleContactSelector,
} from "./component";

export function MergeContactSelector({ sourceClient, children, onSuccess }) {
  const [loadingClientResources, resources] = useClientResources(sourceClient);
  const [isSelectorOpen, openSelector, closeSelector] = useBooleanState();
  const [isConfirmationOpen, openConfirmation, closeConfirmation] =
    useBooleanState();
  const { page, selected, setSelected, setSearchText } = useContactSelector(
    sourceClient.id
  );
  const { merge, isMerging } = useMergeContactAction(
    (client) => {
      closeConfirmation();
      onSuccess(client);
    },
    () => {
      closeConfirmation();
      openSelector();
    }
  );

  return (
    <React.Fragment>
      <Popper
        trigger={children}
        onOpen={openSelector}
        onClose={closeSelector}
        open={isSelectorOpen}
      >
        <SimpleContactSelector
          {...page}
          loading={page.loading || isMerging}
          disabled={(page.fetchCount === 0 && page.loading) || isMerging}
          selected={selected}
          onUpdateSearchText={setSearchText}
          onSelect={(contact) => {
            setSelected(contact);
          }}
        />
        <Button
          disabled={!selected || isMerging || loadingClientResources}
          loading={loadingClientResources}
          fluid
          positive
          style={{ marginTop: "1em" }}
          onClick={(e) => {
            e.stopPropagation();
            closeSelector();
            openConfirmation();
          }}
        >
          Select
        </Button>
      </Popper>
      {isConfirmationOpen && (
        <MergeConfirmationModal
          sourceClient={sourceClient.name}
          targetClient={selected.name}
          loading={isMerging}
          notMergeables={resources}
          onCancel={closeConfirmation}
          onMerge={() => {
            merge(sourceClient, selected);
          }}
        />
      )}
    </React.Fragment>
  );
}

MergeContactSelector.propTypes = {
  sourceClient: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  children: PropTypes.node,
  onSuccess: PropTypes.func.isRequired,
};

MergeContactSelector.defaultProps = {
  children: null,
};

export default MergeContactSelector;
